import React, { useEffect, useState, useRef } from 'react';
import { ArticleService } from '../../../../services/ArticleService';
import { EditionService } from '../../../../services/EditionService';
import { Spinner, Card, Tabs, Tooltip, Row, Col, Accordion, Button, Table, Alert, Form, Dropdown, OverlayTrigger, Popover, InputGroup, FormControl } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import ErrorManager from "../../../../components/error-manager/ErrorManager";
import ConfirmDialog from '../../../../components/confirm-dialog/ConfirmDialog';
import Pagination from '../../../../components/pagination/Pagination';
import { currencyFormat, getFile } from '../../../../helper/Helper'
import { GlobalContext } from "../../../../services/GlobalProvider";
import SendMailDialog from "../../../../components/send-mail-dialog/SendMailDialog";
import PeriodeFilter from "../../../../components/periode-filter/PeriodeFilter";
import { AnalyseService } from '../../../../services/AnalyseService';
import Split from '../../../../components/split/Split';


const ReleveClientDetails = ({ currentClient, dateDebutFin }) => {

    const { globalContextLoaded, preferences, parametres, folderDetails, grants, getPreferences } = React.useContext(GlobalContext);
    const [isReleveClientLoading, setIsReleveClientLoading] = useState(false)
    const [isReleveClientEditionLoading, setIsReleveClientEditionLoading] = useState(false)
    const [releveClientData, setReleveClientData] = useState()
    const [globalError, setGlobalError] = useState()
    const [currentPagination, setCurrentPagination] = useState(1)

    let editionParams = useRef({});
    let releveParams = useRef({});

    useEffect(() => {
        setDefaultValues()
        if(dateDebutFin) {
            editionParams.current["filter"]["date"] = `${dateDebutFin.dateDebut ? `>=${dateDebutFin.dateDebut}` : ""}${dateDebutFin.dateFin ? `&<=${dateDebutFin.dateFin}` : ""}`
            releveParams.current["filter"]["date"] = `${dateDebutFin.dateDebut ? `>=${dateDebutFin.dateDebut}` : ""}${dateDebutFin.dateFin ? `&<=${dateDebutFin.dateFin}` : ""}`
        }
        getAnalyse()
    }, [currentClient, dateDebutFin]);

    function setDefaultValues() {

        editionParams.current = {
            'include_lettrees': false,
            'include_soldees': false,
            'filter': {},
            'clients': [currentClient._id]
        };

        releveParams.current = {
            'start': 0,
            'limit': null,
            'search': null,
            'filters': null,
            'filter': {},
            'sort': null,
            'order': null,
            'fields': null,
            'include_lettrees': false,
            'include_soldes': false,
            'limit': 10
        };

        setCurrentPagination(1)

    }

    function getAnalyse() {
        setIsReleveClientLoading(true)
        AnalyseService.getAnalyses(folderDetails?.dossier?._id, releveParams.current, "analyses/relevesclients/" + currentClient._id).then(res => {
            if (res.status == 204 || !res?.data) {
                setReleveClientData()
                setGlobalError({ statusText: `Aucun résultat n'a été trouvé (${res.statusText})` })
            } else {
                setReleveClientData(res?.data?.data)
                setGlobalError()
            }
            setIsReleveClientLoading(false)
        }).catch(error => {
            setGlobalError(error)
            setIsReleveClientLoading(false)
        });
    }

    function getEdition(format) {
        setIsReleveClientEditionLoading(true)
        EditionService.getEditions(folderDetails?.dossier?._id, editionParams.current, "analyses/relevesclients", format).then(res => {
            setIsReleveClientEditionLoading(false)
            if (res.status == 204 || !res?.data) {
                setGlobalError({ statusText: `Aucun résultat n'a été trouvé (${res.statusText})` })
            } else {
                setGlobalError()
                getFile(res, format)
            }
        }).catch(error => {
            setIsReleveClientEditionLoading(false)
            setGlobalError(error)
        });
    }

    function changePagination(p) {
        setCurrentPagination(p)
        releveParams.current['start'] = (releveParams.current.limit * p) - releveParams.current.limit
        getAnalyse()
    }

    function changeLimit(l) {
        releveParams.current['limit'] = l
        changePagination(1)
    }

    function changeParams(e) {
        editionParams.current[e.target.name] = e.target.checked
        releveParams.current[e.target.name] = e.target.checked
        getAnalyse()
    }

    return (
        <>
            <div className="d-flex mb-4">
                <div className="me-auto">
                    <h6 className="m-0">{currentClient.nom}<span className="text-gray-500 ms-2">{currentClient.code}</span></h6>
                </div>
            </div>
            <div className="tab-pane light-v-scroll height-full-min-200 mt-5 pe-2">
                <Row>
                    <Col>
                        <div className="d-flex align-items-center mb-4">
                            <span className="ms-auto p-2 bg-gray-100 me-2 rounded d-inline-flex">
                                <Form.Check
                                    className="m-0 me-2"
                                    type="checkbox"
                                    name="include_lettrees"
                                    checked={releveParams.current.include_lettrees}
                                    onClick={changeParams}
                                    label="Inclure lettrées"
                                />
                            </span>
                            <span className="p-2 bg-gray-100 me-2 rounded d-inline-flex">
                                <Form.Check
                                    className="m-0 me-2"
                                    type="checkbox"
                                    name="include_soldes"
                                    checked={releveParams.current.include_soldes}
                                    onClick={changeParams}
                                    label="Inclure soldés"
                                />
                            </span>
                            <Button disabled={isReleveClientEditionLoading} onClick={() => getEdition("pdf")}>
                                {isReleveClientEditionLoading &&
                                    <Spinner animation="border" size="sm" className="me-2" />
                                }
                                Télécharger le relevé (PDF)
                            </Button>
                        </div>
                        <ErrorManager error={globalError} />
                        {isReleveClientLoading ?
                            <div className="">
                                <span className="hloader"></span>
                            </div>
                            :
                            <>
                                {releveClientData && (
                                    <>
                                    {(dateDebutFin?.dateDebut && dateDebutFin?.dateFin) &&
                                        <p><b>Période : </b>Du {dateDebutFin?.dateDebut ? new Date(dateDebutFin.dateDebut).toLocaleDateString() : ""} au {dateDebutFin?.dateFin ? new Date(dateDebutFin.dateFin).toLocaleDateString() : ""} : </p>
                                    }
                                    {(dateDebutFin?.dateDebut && !dateDebutFin?.dateFin) &&
                                        <p><b>Période : </b>À partir du {dateDebutFin?.dateDebut ? new Date(dateDebutFin.dateDebut).toLocaleDateString() : ""} : </p>
                                    }
                                    {(!dateDebutFin?.dateDebut && dateDebutFin?.dateFin) &&
                                        <p><b>Période : </b>Jusqu'au {dateDebutFin?.dateFin ? new Date(dateDebutFin.dateFin).toLocaleDateString() : ""} : </p>
                                    }

                                        <Split title="Total débit" value={releveClientData?.total_factures_periode} border />
                                        <Split title="Total crédit" value={releveClientData?.total_reglements_periode} border />
                                        <Split title="Solde final" value={releveClientData?.solde_final} border />
                                        <Split border title="Nombre de factures" value={releveClientData?.nombre_factures} />
                                        <Split border title="Nombre de règlements" value={releveClientData?.nombre_reglements} />
                                        <Split title={releveClientData?.total + " Opérations :"} value="" />
                                        {releveClientData?.operations?.length == 0 ?
                                            <em className="">- Aucune opération trouvée -</em>
                                            :
                                            <Accordion alwaysOpen>
                                                {releveClientData?.operations.map((operation, index) => (
                                                    <Accordion.Item key={operation._id} eventKey={operation._id} className="border-0 mb-2">
                                                        <Accordion.Header>{operation.type}, le {new Date(operation.date).toLocaleDateString()}</Accordion.Header>
                                                        <Accordion.Body className="px-1">
                                                            <Split title="Libellé" value={operation.libelle} border />
                                                            <Split title="Débit" value={operation.debit} border />
                                                            <Split title="Crédit" value={operation.credit} border />
                                                            <Split title="Solde" value={operation.solde} />
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                ))}
                                            </Accordion>
                                        }
                                        <Pagination className="mt-3" itemsLength={releveClientData?.total} elementsPerPage={releveParams.current.limit} currentPagination={currentPagination} changePagination={p => changePagination(p)} showChangeLimit changeLimit={l => changeLimit(l)} />

                                    </>
                                )}
                            </>
                        }
                    </Col>
                </Row>
            </div>
        </>
    );
}
export default ReleveClientDetails;